import AsyncComponent from './AsyncComponent.jsx';
export default AsyncComponent;



// WEBPACK FOOTER //
// ./src/components/AsyncComponent/index.js